<template>
  <div>
    <van-empty v-if="orderInfo.length<='0'" description="当前没有正在服务中的订单" />
   <Orderlist v-else :orderInfo="orderInfo" :total="total" :formData="formData"></Orderlist>
    <Tabbar></Tabbar>
  </div>
</template>

<script>
import Tabbar from '../components/tabbar.vue'
import Orderlist from '../components/orderlist.vue'
import { Toast } from 'vant'
export default{
  name: 'service', // 服务页面
  components: {
    'Tabbar': Tabbar,
    'Orderlist': Orderlist
  },
  data () {
    return {
      online: true, // 员工是否在线   true在线   false 下线
      orderInfo: [], // 订单数据

      // 列表查询参数
      formData: {
        pageNum: 1,
        pageSize: 10
      },
      total: '',
      flag: true
    }
  },
  created () {
    this.getIndexInfo(this.formData)
  },
  mounted () {

  },

  methods: {
    // 请求数据
    getIndexInfo (formData) {
      var that = this
      // if (!that.hasMore) { return }
      if (that.flag == false) { return }
      that.flag = false
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })
      that.hasMore = false
      this.$api.HZrequest('/we-chat/gzh/get-current-orders', 'GET', formData).then((res) => {
        // that.hasMore = res.hasMore
        if (res.rows.length > 0) {
          that.total = res.total
          that.orderInfo = that.orderInfo.concat(res.rows)
          that.flag = true
        }
        setTimeout(function () {
          Toast.clear()
        }, 500)
      })
    }

  }

}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/service.vue